import React, { useEffect, useState } from "react";
import { Table, Button, Flex } from "antd";
import ENDPOINTS from "../../../../services/endpoint";
import apiInstance from "../../../../services/apiService";
import { toast } from "react-toastify";
import CustomLoader from "../../../common/UI/Loader";
import "./index.scss";
import { customLogger } from "../../../../utils/Logger";

interface Invoice {
  balance: number;
  currency_code: string;
  currency_symbol: string;
  due_date: string;
  invoice_date: string;
  invoice_id: string;
  invoice_number: string;
  number: string;
  status: string;
  total: number;
  transaction_type: string;
}

const columns = [
  {
    dataIndex: "invoice_date",
    key: "invoice_date",
  },
  {
    dataIndex: "transaction_type",
    key: "transaction_type",
  },
  {
    dataIndex: "status",
    key: "status",
  },
];

const BillingHistory: React.FC = () => {
  const [visibleRows, setVisibleRows] = useState(4);
  const [loading, setLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<Invoice[]>([]);
  const [viewText, setViewText] = useState("View More");

  const handleViewMore = () => {
    setVisibleRows((prev) => (prev <= 4 ? Math.min(tableData?.length) : 4));
    setViewText((prev) => (prev === "View More" ? "View Less" : "View More"));
  };

  const getBillingData = async () => {
    const url = ENDPOINTS.BILLING_DETAILS;

    setLoading(true);
    try {
      const response = await apiInstance.get(url);
      const data = response.data.data.billingDetails;
      setTableData(data);
    } catch (error: any) {
      customLogger(error);
      toast.error(error.message || "There was an error. Please try again");
    } finally {
      setLoading(false);
    }
  };

  const getURLforInvoice = async (data: Invoice) => {
    const invoiceId = data.invoice_id;

    if (!data.invoice_id) {
      toast.error("Invalid Invoice");
      return;
    }

    const url = ENDPOINTS.BILLING_DETAILS + `?invoice_id=${invoiceId}`;

    setLoading(true);
    try {
      const response = await apiInstance.get(url);
      const invoiceURL = response.data.data.invoice_url;

      if (invoiceURL) {
        window.open(invoiceURL, "_blank");
      } else {
        toast.error("No invoice found");
      }
    } catch (error: any) {
      customLogger(error);
      toast.error(error.message || "There was an error. Please try again");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBillingData();
  }, []);

  return (
    <div className="transaction-table-container">
      <Table
        rowHoverable={false}
        columns={columns}
        dataSource={tableData?.slice(0, visibleRows)}
        pagination={false}
        className="transaction-table"
        showHeader={false}
        onRow={(record: Invoice) => ({
          className: 'row-clickable',
          onClick: () => getURLforInvoice(record),
        })}
        loading={{
          spinning: loading,
          indicator: (
            <Flex className="w-full h-full" justify="center" align="center">
              <CustomLoader />,
            </Flex>
          ),
        }}
      />
      {tableData.length > 0 && (
        <div className="view-more">
          <Button type="link" onClick={handleViewMore}>
            {viewText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default BillingHistory;
